import { GeneralBlock, Report } from './report/Report';

export default function setMergedReportIndices(
  reports: Report[],
  general: GeneralBlock
): void {
  const merged: Set<number> = new Set();
  reports.forEach(r => {
    merged.add(r.general.reportIndex);
    const indices: number[] | undefined = r.general.mergedReportIndices;
    if (indices) {
      indices.forEach(m => merged.add(m));
    }
  });
  if (merged.size > 0) {
    general.mergedReportIndices = [...merged].sort((a, b) => a - b);
  }
}
